/// <reference path="BasicInput.ts" />

namespace ui
{
	export namespace Form
	{

		export class TelInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'tel', InputValueTypes.STRING );
			}

			public value( val: string | null ): TelInput
			{
				return super.value( val );
			}

			public val(): string|null
			{
				return ( this.m_Root.val() as string ).toString() || null;
			}

		}

		export class FaxInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'tel', InputValueTypes.STRING );
			}

			public value( val: string | null ): TelInput
			{
				return super.value( val );
			}

			public val(): string|null
			{
				return ( this.m_Root.val() as string ).toString() || null;
			}

		}

		export class EmailInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'email', InputValueTypes.STRING );
			}

			public value( val: string | null ): TelInput
			{
				return super.value( val );
			}

			public val(): string|null
			{
				return ( this.m_Root.val() as string ).toString() || null;
			}

		}

		export class URLInput
			extends Input
		{

			public constructor( value: string, descriptor: IBasicInputDescriptor )
			{
				super( value, descriptor, 'url', InputValueTypes.STRING );
			}

			public value( val: string | null ): TelInput
			{
				return super.value( val );
			}

			public val(): string|null
			{
				return ( this.m_Root.val() as string ).toString() || null;
			}

		}

	}
}
